module.exports = __webpack_public_path__ + "assets/media/4.3c1bccca.wav";